import { getMessaging, getToken } from 'firebase/messaging';
import { firebaseApp } from '../config/firebase';
import api from '../../api/axios';

const LOCAL_STORAGE_KEY = 'push_notification_token';

/**
 * Initializes browser notifications and synchronizes FCM token with the backend.
 */
export const setupBrowserNotifications = async (): Promise<void> => {
  if (!('Notification' in window) || !('serviceWorker' in navigator)) return;

  try {
    const messaging = getMessaging(firebaseApp);

    let permission = Notification.permission;

    if (permission === 'default') {
      permission = await Notification.requestPermission();
    }

    if (permission !== 'granted') {
      return;
    }

    /** Wait for the active Service Worker registration to avoid refetching script on localhost */
    const registration = await navigator.serviceWorker.ready;

    /** Pass active registration to FCM */
    const token = await getToken(messaging, {
      vapidKey: '...',
      serviceWorkerRegistration: registration
    });

    if (!token) return;

    const syncedToken = localStorage.getItem(LOCAL_STORAGE_KEY);

    if (syncedToken !== token) {
      await api.post('/notifications/tokens/sync', {
        token,
        deviceInfo: navigator.userAgent
      });

      localStorage.setItem(LOCAL_STORAGE_KEY, token);
    }
  } catch (error) {
    console.error('Failed to sync push token:', error);
  }
};